import React, { useMemo } from "react";
import {
    Box,
    Button,
    IconButton,
    InputAdornment,
    Paper,
    Stack,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import {
    AddCircle as AddIcon,
    Search as SearchIcon,
} from "@mui/icons-material";

const AvailableLocationsPanel = ({
    locations = [],
    searchTerm,
    setSearchTerm,
    onAdd,
    onCreateLocation,
}) => {
    const filteredLocations = useMemo(() => {
        const term = String(searchTerm || "").trim().toLowerCase();

        return locations.filter((location) =>
            String(location.locnom || "").toLowerCase().includes(term)
        );
    }, [locations, searchTerm]);

    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2,
                borderRadius: 2.5,
                height: "100%",
                backgroundColor: "#fafafa",
            }}
        >
            <Stack spacing={1.5}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Box>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Localizaciones disponibles
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Agrega paradas a la ruta del manifiesto.
                        </Typography>
                    </Box>

                    <Button size="small" variant="outlined" onClick={onCreateLocation}>
                        Nueva
                    </Button>
                </Stack>

                <TextField
                    placeholder="Buscar localización..."
                    size="small"
                    fullWidth
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                />

                <Box maxHeight={470} overflow="auto" pr={0.5}>
                    {filteredLocations.length === 0 ? (
                        <Box
                            sx={{
                                p: 3,
                                border: "1px dashed #cfd8dc",
                                borderRadius: 2,
                                textAlign: "center",
                                backgroundColor: "#fff",
                            }}
                        >
                            <Typography variant="body2" color="text.secondary">
                                No se encontraron localizaciones.
                            </Typography>
                        </Box>
                    ) : (
                        filteredLocations.map((location) => (
                            <Paper
                                key={location.locid}
                                variant="outlined"
                                sx={{
                                    p: 1,
                                    mb: 1,
                                    borderRadius: 2,
                                    backgroundColor: "#fff",
                                }}
                            >
                                <Stack direction="row" justifyContent="space-between" alignItems="center">
                                    <Box minWidth={0}>
                                        <Typography variant="body2" fontWeight="bold" noWrap>
                                            {location.locnom}
                                        </Typography>

                                        {(location.loclat || location.loclng) && (
                                            <Typography variant="caption" color="text.secondary">
                                                {location.loclat || "-"}, {location.loclng || "-"}
                                            </Typography>
                                        )}
                                    </Box>

                                    <Tooltip title="Agregar parada">
                                        <IconButton color="primary" size="small" onClick={() => onAdd(location)}>
                                            <AddIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                            </Paper>
                        ))
                    )}
                </Box>
            </Stack>
        </Paper>
    );
};

export default AvailableLocationsPanel;